import { Line } from "vue-chartjs";
import "chartjs-plugin-datalabels";

export default {
  extends: Line,
  props: {
    color: String,
    label: String,
    history: Object
  },
  data: function() {
    return {
      chartdata: {
        labels: this.history.datas,
        datasets: [
          {
            label: this.label,
            data: this.history.valores,
            backgroundColor: this.color,
            borderColor: this.color,
            fill: false,
            lineTension: 0,
            borderWidth: 12,
            pointBorderColor: this.secondaryColor
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 80,
        tooltips: {
          enabled: true
        },
        title: {
          display: false
        },
        legend: {
          display: false
        },
        layout: {
          padding: {
            left: 20,
            top: 0,
            bottom: 0,
            right: 20
          }
        },
        scales: {
          yAxes: [
            {
              ticks: {
                fontColor: "#f0f0f0",
                fontSize: 0,
                min: -30,
                max: 160
              },
              gridLines: {
                display: false,
                drawBorder: false
              }
            }
          ],
          xAxes: [
            {
              ticks: {
                fontColor: "#f0f0f0",
                fontSize: 16
              },
              gridLines: {
                display: false,
                drawBorder: false
              }
            }
          ]
        },
        plugins: {
          datalabels: {
            align: "top",
            color: "#f0f0f0",
            font: {
              size: "20"
            }
          }
        }
      }
    };
  },
  mounted() {
    this.renderChart(this.chartdata, this.options);
  },
  methods: {
    updateHistory(valores, datas) {
      this.chartdata = {
        ...this.chartdata,
        labels: datas,
        datasets: [{ ...this.chartdata.datasets[0], data: valores }]
      };
    }
  },
  watch: {
    history: {
      handler() {
        this.updateHistory(this.history.valores, this.history.datas);
        this.$data._chart.destroy();
        this.renderChart(this.chartdata, this.options);
      }
    }
  },
  computed: {
    secondaryColor() {
      switch (this.color) {
        case "#006064":
          return "#00897B";
        case "#36A2EB":
          return "#46B2FB";
      }
    }
  }
};
